import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'

import { MatIcon } from '@angular/material/icon'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatTableModule } from '@angular/material/table'

import { ButtonComponent } from '../../../../../components/button/button.component'

export type ErrorRow = {
  email: string
  name: string
}

export interface ZoomUserNotFoundWarningComponentData {
  errors: ErrorRow[]
}

@Component({
  selector: 'app-amptalk-integration-error',
  standalone: true,
  imports: [MatIcon, MatTableModule, ButtonComponent],
  templateUrl: './zoom-user-not-found-warning.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./zoom-user-not-found-warning.component.scss'],
})
export class ZoomUserNotFoundWarningComponent {
  displayedColumns: string[] = ['email', 'name']
  errors: ErrorRow[] = [{ email: 'hoge@example.com', name: '山田 太郎' }]

  constructor(
    private dialogRef: MatDialogRef<ZoomUserNotFoundWarningComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: ZoomUserNotFoundWarningComponentData,
  ) {
    this.errors = data.errors
  }

  close(): void {
    this.dialogRef.close()
  }
}
